@use "../../styles/colors";

.container {
  width: 100%;
  position: relative;

  @include colors.define-best-supported-color-value(
    "--ixf-table-overlay-color",
    color(from var(--ixf-color-background) srgb r g b / 0.8),
    color(from var(--ixf-color-background) display-p3 r g b / 0.8)
  );

  @include colors.define-best-supported-color-value(
    "--ixf-table-fixed-column-shadow-color",
    color(from var(--ixf-text-tone-md) srgb r g b / 0.05),
    color(from var(--ixf-text-tone-md) display-p3 r g b / 0.05)
  );

  &.hasNoDataForFilters .noMatchContainer,
  .noDataContainer {
    position: sticky;
    top: 50%;
    left: 0;
    z-index: 11;

    .content {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .tableContainer {
    --ixf-table-pinned-column-right-box-shadow: none;
    --ixf-table-pinned-column-left-box-shadow: none;

    position: relative;
    overflow-x: auto;
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
    scroll-behavior: smooth;

    &:focus {
      outline: none;
    }

    &.isEmpty {
      .table {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          z-index: 10;
          background: var(--ixf-table-overlay-color);
        }
      }
    }

    &.hasXOverflow {
      --ixf-table-pinned-column-right-box-shadow: -4px 0 16px 0
        var(--ixf-table-fixed-column-shadow-color);
      --ixf-table-pinned-column-left-box-shadow: 4px 0 16px 0
        var(--ixf-table-fixed-column-shadow-color);
    }
  }
}

.table {
  --ixf-table-border-color: var(--ixf-color-separator);
  --ixf-table-header-border-color: var(--ixf-color-separator);
  --ixf-table-border: 1px solid var(--ixf-table-border-color);
  --ixf-table-header-border: 1px solid var(--ixf-table-header-border-color);
  --ixf-table-cell-spacing-horizontal: var(--ixf-space-2);
  --ixf-table-cell-spacing-vertical: var(--ixf-space-1);
  --ixf-table-header-cell-spacing-horizontal: var(
    --ixf-space-2,
    var(--ixf-table-cell-spacing-horizontal)
  );
  --ixf-table-header-cell-spacing-vertical: var(
    --ixf-space-1,
    var(--ixf-table-cell-spacing-vertical)
  );

  display: block;
  min-width: fit-content;

  &.horizontalBorderless {
    --ixf-table-header-border-color: transparent;
  }

  .pendingData {
    width: 100%;
  }
}
